import React from 'react';
import {
    ElementMetadataSectionName,
    IElementDataSectionRelatedLinkedReports,
} from 'components/common/element-data/types';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import LinkedReports from 'components/common/element-data/parts/LinkedReports';
import useBundleTranslation from 'i18n';
import { getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function RelatedLinkedReportsSection(props: IElementDataSectionRelatedLinkedReports) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'related_linked_reports';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);

    return (
        <ElementDataSection
            adjustableDisplayTitle={false}
            title={t(`element_data_section_label.${sectionKey}`)}
            order={sectionMetadataOrder}
        >
            <LinkedReports {...element} settings={settings} />
        </ElementDataSection>
    );
}
